export default interface RepDiscipline {
	repDisciplineId: number;
	representativeId: number;
	repIncidentId?: number;
	type: RepDisciplineType;
	typeId: number;
	typeName: string;
	reason: RepDisciplineReason;
	reasonId: number;
	reasonName: string;
	reasonText: string;
	assignedTrainingId: string;
	assignedTrainings: RepAdditionalTraining[];
	assignedTrainingName: string;
	assignedStatus: string;
	featureId?: number;
	feature?: RepFeature;
	startDate?: Date;
	endDate?: Date;
	segmentId: number[];
	applyExternal: boolean;
}

export interface RepFeature {
	id: number;
	name: string;
	active: boolean;
}

export interface RepDisciplineHistory {
	repDisciplineHistoryId: number;
	repDisciplineId: number;
	timestamp: Date;
	message: string;
	userId: number;
	userName: string;
}

export interface RepAdditionalTraining {
	id: number;
	repDisciplineId?: number;
	status: string;
	trainingId: number;
	trainingName: string;
	createdOn: Date;
}

export enum RepDisciplineType {
	Probation = 1,
	Suspension = 2,
	Blocklist = 3,
	FeatureSuspension = 4,
}

export enum RepDisciplineReason {
	Complaint = 1,
	Onboarding = 2,
	InternalReview = 3,
	Alert = 4,
}
